<template>
<div>
  <app-masthead :header="header"/>
  <v-container>
    <v-layout wrap row class="mb-5">
      <v-flex xs12>
        <h2 style="font-size: 36px; font-weight: bold; line-height: 1.2;" class="mb-2">Der Mix macht's!</h2>
        <p>Einmal im Monat fliegen bei uns die Ideenfunken! In geselliger, bunt gemischter Runde hast du die Möglichkeit einer von zehn Teilnehmern zu sein, der von den Impulsen in Form von Ideen und Erfahrungswerten anderer profitiert. Jeder ist bei uns willkommen!</p>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm6
        v-for="(event, eInd) in events" :key="eInd"
        class="mb-5"
      >
        <v-card class="elevation-5 ma-2" style="border-radius: 8px">
          <v-img :src="event.logo.url">
            <v-layout pa-2 column fill-height class="lightbox white--text">
            <v-spacer></v-spacer>
            <v-flex shrink>
              <h3>{{ event.name.text }}</h3>
            </v-flex>
          </v-layout>
          </v-img>
          <v-card-title>
            <div>              
              <div>{{ date(event) }}</div>
              <div>{{ time(event) }}</div>
              <div>Ticket: 18 EUR</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn outline color="warning" :href="event.url" target="_blank">zum Event<v-icon right>arrow_right_alt</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex style="text-align: center;">
        <v-btn color="warning" class="elevation-0" href="https://www.eventbrite.de/o/ideenpioniere-18467151460" target="_blank"><v-icon left>link</v-icon>alle Events bei Eventbrite</v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12>
        <v-card flat class="pa-3 my-5">
          <v-card-title>
            <h3>Deine Frage oder Herausforderung</h3>
              <p>
              Du möchtest von den Erfahrungen und Ideen der Teilnehmer profitieren? Stell uns deine Frage! Hier ein paar Tipps, wie du in kurzer Zeit deine Frage oder Herausforderung an die Teilnehmer stellen kannst.
              <br>
              Natürlich bieten wir dir auch an, dass wir vorher über dein Thema (egal ob Herausforderung oder Frage) drüberschauen.
              </p>
          </v-card-title>
          <v-card-actions>
            <v-btn color="warning" class="elevation-0" href="mailto:hello@ideenpioniere.de?subject=Ideenparty :: Frage bzw. Herausforderung"><v-icon left>mail</v-icon> E-Mail schreiben</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import eventbrite from '@/plugins/eventbrite'

export default {
  created() {
    eventbrite.get('/organizations/' + this.organization_id + '/events/?status=live')
    .then(response => {
      this.events = response.data.events
      // console.log(response.data.events)
    })
    .catch()
  },
  data () {
    return {
      events: null,
      organization_id: '287593729976',
      header: {
        src: require('@/assets/ip-header-ideenparty.svg'),
        title: 'Zusammen. Impulse. Austauschen.',
        description: 'Auf unseren Ideenparties findet ein reger Austausch von Impulsen und Inspirationen für deine Fragen und Herausforderungen statt!'
      }
    }
  },
  methods: {
    date (event) {
      let date = new Date(Date.parse(event.start.local))
      let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      let formatted = date.toLocaleDateString('de-DE', options)
      return formatted
    },
    time (event) {
      let options = { hour: '2-digit', minute: '2-digit' }
      let timeStart = new Date(Date.parse(event.start.local)).toLocaleTimeString('de-DE', options)
      let timeEnd = new Date(Date.parse(event.end.local)).toLocaleTimeString('de-DE', options)
      return timeStart + ' bis ' + timeEnd + ' Uhr'
    }
  }
}
</script>
